import { GroupPeriodPicker } from './group-period-picker';

type Props = {
  selectedPeriods: string[];
  onChange: (periods: string[]) => void;
};

/**
 * Group dashboard's global period filter. Renders the mock GroupPeriodPicker
 * (hardcoded calendar years 2024–2026) directly — Phase 2 will swap the data
 * source for backend-aggregated child-org periods on `/group/account/`.
 */
export function GroupPeriodFilter({ selectedPeriods, onChange }: Props) {
  return (
    <GroupPeriodPicker selectedPeriods={selectedPeriods} onChange={onChange} />
  );
}
